import React from "react";
import { NavBarBrand } from "./nav-bar-brand";
import { NavBarButtons } from "./nav-bar-buttons";
import {useAuth0} from "@auth0/auth0-react";
import {Button, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown} from "reactstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {NavBarTabs} from "./nav-bar-tabs-staging";
import NavTabs from "./nav-bar-tabs";

export const NavBar = () => {

    const {
        user,
        isAuthenticated,
        isLoading,
        getAccessTokenSilently,
        loginWithRedirect,
        logout,
    } = useAuth0();

    const logoutWithRedirect = () =>
        logout({
            logoutParams: {
                returnTo: window.location.origin,
            }
        });

    // Prevent rendering until Auth0 is ready to avoid flash of old styles
    if (isLoading) {
        return <div className="fl-tabs" style={{ visibility: 'hidden', height: 0, overflow: 'hidden' }} />;
    }

  return (
    <div className="fl-tabs">

        <div className={"row"}>
            <div className={"col-md-4"}>
                <NavBarBrand/>
            </div>


            <div className={"col-md-8"}>
                <NavTabs/>
            </div>



        </div>
        {/*<NavBarButtons />*/}
    </div>
  );
};